import client from './client';

// Xem trạng thái + kết quả lần quét gần nhất (đơn lọc theo quyền: NV=đơn mình, TP/GĐ=tất cả).
export const getYahooState = () => client.get('/yahoo-scan/state').then((r) => r.data);

// Trưởng phòng/GĐ bấm quét (chạy nền). Trả về ngay { started } hoặc { running }.
export const startYahooScan = () => client.post('/yahoo-scan/daily').then((r) => r.data);

// Đánh dấu 1 đơn đã/chưa xử lý (NV chỉ sửa được đơn của mình).
export const setYahooHandled = (code, handled) => client.post('/yahoo-scan/handle', { code, handled }).then((r) => r.data);
